var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    typography = _ref.typography;
  return {
    legendRectFillColor: colors.contrasts.blue4570,
    legendPadding: spacing.small,
    legendBorderColor: colors.contrasts.grey4570,
    legendFontSize: typography.fontSizeXSmall,
    legendMargin: spacing.medium
  };
};
export default generateComponentTheme;